/**
 * @generated SignedSource<<9a5dbd89f1608afbfce55cf859f9fa7b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type NoteStreamType = "goalset" | "meeting" | "oneonone" | "personal";
import { FragmentRefs } from "relay-runtime";
export type QuotedItemBlock$data = {
  readonly descendants: ReadonlyArray<{
    readonly document: any;
  }>;
  readonly document: any;
  readonly note: {
    readonly id: string;
    readonly noteType: NoteStreamType;
  };
  readonly " $fragmentType": "QuotedItemBlock";
};
export type QuotedItemBlock$key = {
  readonly " $data"?: QuotedItemBlock$data;
  readonly " $fragmentSpreads": FragmentRefs<"QuotedItemBlock">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "document",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "QuotedItemBlock",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteBlock",
      "kind": "LinkedField",
      "name": "descendants",
      "plural": true,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "note",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "noteType",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NoteBlock",
  "abstractKey": null
};
})();

(node as any).hash = "520a560a053a4cf2dea6148c4058b789";

export default node;
